import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CompaniesTable = _resolveComponent("CompaniesTable")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_layout, { warp: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_CompaniesTable, {
            editable: true,
            showParentCompany: true
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}